import React from 'react';
import PropTypes from 'prop-types';
import ImageLoader from 'react-loading-image';
import classnames from 'classnames';

import { Spinner } from '@breezeway/brzw-components';
import { image } from '../../utils';

import './cloudinary_image.scss';

const CloudinaryImage = props => {
  const { bucket, photoKey, options, className, withLoader } = props;

  const publicId = bucket ? `${bucket}/${photoKey}` : photoKey;
  const imageUrl = image.getCloudinaryUrl(publicId, options);
  return withLoader ? (
    <ImageLoader
      src={imageUrl}
      className={className}
      loading={() => (
        <div className={classnames('image', className, 'image-spinner')}>
          <Spinner />
        </div>
      )}
      error={() => (
        <div className={classnames('image', className, 'image-error')}>
          Error loading <br /> image
        </div>
      )}
    />
  ) : (
    <img src={imageUrl} className={className} alt="" />
  );
};

CloudinaryImage.propTypes = {
  bucket: PropTypes.string,
  className: PropTypes.string,
  photoKey: PropTypes.string,
  options: PropTypes.shape({}),
  withLoader: PropTypes.bool,
};

CloudinaryImage.defaultProps = {
  withLoader: false,
};

export default CloudinaryImage;
